import React from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../../state";
import { MutateTPMSConfig } from "../../../../utils/graphql/hooks/TPMSHooks";
import toast from "react-hot-toast";

interface AddTyreDialogProps {
  isOpen: boolean;
  showDialog: (newState: boolean) => void;
  group: string | null;
}

function shake() {
  const dialog = document.getElementsByClassName("dialog");
  if (dialog.length > 0) {
    for (const el of dialog) {
      el.classList.add(styles.shaking);
      setTimeout(() => {
        el.classList.remove(styles.shaking, styles.shouldGrow);
      }, 500);
    }
  }
}

export default function AddTyreDialog(props: AddTyreDialogProps) {
  const { isOpen, showDialog, group } = props;
  const selectedCar = useSelector(
    (state: RootState) => state.tpms.selectedCar,
  ) as string;
  const tpmsConfig = useSelector((state: RootState) => state.tpms.tpmsConfig);
  const updateTPMSConfig = MutateTPMSConfig();

  const tyreConfig = tpmsConfig ? tpmsConfig.tyres : [];
  const isFront = group?.toLowerCase() === "front" ? true : false;

  const tyreIDElement = document.getElementById(
    `TyreIDInput${group}`,
  ) as HTMLInputElement;
  const sensorIDElement = document.getElementById(
    `SensorIDInput${group}`,
  ) as HTMLInputElement;

  function closeDialog() {
    if (tyreIDElement) tyreIDElement.value = "";
    if (sensorIDElement) sensorIDElement.value = "";
    showDialog(false);
  }

  function submitTyre(event: React.MouseEvent<HTMLElement>) {
    event.preventDefault();

    const tyreId = tyreIDElement.value;
    const sensorId = sensorIDElement.value;

    if (tyreId && sensorId) {
      const thisTyreObj = {
        carId: selectedCar,
        tyreId: tyreId,
        sensorId: sensorId,
        isFront: isFront,
      };

      console.log("ADD", thisTyreObj);

      updateTPMSConfig({
        variables: {
          tyres: [...tyreConfig, thisTyreObj],
        },
      })
        .then(() => {
          closeDialog();
        })
        .catch((e) => {
          const errMsg = e.graphQLErrors[0].message;
          toast.error(errMsg);
          shake();
        });
    } else {
      shake();
    }
  }

  return (
    <div
      style={!isOpen ? { display: "none" } : {}}
      className={styles.dialogContainer}
    >
      <div className={`${styles.dialog} ${styles.shouldGrow} dialog`}>
        <div className={styles.title}>
          New {group} Tyre - Car {selectedCar}
        </div>
        <form>
          <div>
            <p>
              <label>Tyre ID:</label>
              <input id={`TyreIDInput${group}`} type="text" autoFocus />
            </p>
            <p>
              <label>Sensor ID:</label>
              <input id={`SensorIDInput${group}`} type="number" />
            </p>
            <p></p>
          </div>
          <div>
            <button className={styles.submitButton} onClick={submitTyre}>
              Submit
            </button>
          </div>
        </form>
      </div>
      <div
        className={styles.backgroundBlur}
        onClick={() => closeDialog()}
      ></div>
    </div>
  );
}
